const regex = /<\s*p[^>]*>|<\s*\/\s*p>/g
export default (html) => {
  return html.replace(regex, '').replace(/&nbsp;/g, ' ')
}